import { Component, OnInit, Input } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap';

@Component({
  selector: 'app-faturamento-pj',
  templateUrl: './faturamento-pj.component.html',
  styleUrls: ['./../cadastral-pj/cadastral-pj.component.css','./faturamento-pj.component.css']
})
export class FaturamentoPjComponent implements OnInit {

  @Input() dados:any;
  public txtButtonConsultar:string='Consultar agora';
  public consultando:Boolean=false;
  public naoSolicitou:Boolean=false;
  public naoEncontrouRegistros:Boolean=false;
  public modalRef:BsModalRef;

  constructor(private modalService:BsModalService) { }
  

  ngOnInit() {
    if(this.dados.faturamento===undefined){
      this.naoSolicitou=true;
    }else if(this.dados.faturamento===null){
      this.naoEncontrouRegistros=true;
    }
  }

}
